import { trpc } from '@/shared/api/trpc';
import {
  NOTIFICATION_POLL_MS,
  notificationPollInterval,
} from './use-unread-count';

/** The drawer opens on a full first page… */
export const NOTIFICATION_PAGE_SIZE = 20;
/** …and grows in smaller steps, so "show more" is a glance, not a jump. */
export const NOTIFICATION_NEXT_PAGE_SIZE = 10;

/** The one input the provider polls — also the cache key mark-read patches. */
export const notificationListInput = {
  limit: NOTIFICATION_PAGE_SIZE,
  nextLimit: NOTIFICATION_NEXT_PAGE_SIZE,
};

// Paged notification list. Keyset ("cursor") pagination, so pages stay stable
// while new notifications arrive at the top — an offset page would shift rows
// and show duplicates.
//
// Polled on the same cadence as the badge, and NOT gated on the drawer being
// open: this list is also what the provider diffs to detect a newly arrived
// notification and raise its toast, so it has to run whenever the bell does.
// See use-unread-count.ts for why `refetchIntervalInBackground` is required.
//
// The drawer opens on `limit` rows and grows by `nextLimit` per "Show N more".
// Both live on the (constant) input rather than on the page param, so the query
// key never changes and paging costs no extra refetch.
//
// Note an infinite query refetches every page it has loaded, so this is cheap
// for the common single-page case and grows as the user pages down.
export const useNotifications = (enabled: boolean) =>
  trpc.notifications.list.useInfiniteQuery(notificationListInput, {
    enabled,
    refetchInterval: notificationPollInterval,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    staleTime: NOTIFICATION_POLL_MS / 2,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  });
